var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeHiddenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.4082V17.4082M12 15.4082C13.1314 15.4082 14.1262 15.2489 15 14.9784M12 15.4082C10.8686 15.4082 9.87376 15.2489 9 14.9784M15 14.9784L16 16.9082M15 14.9784C16.1703 14.616 17.1234 14.0542 17.8963 13.4082L19.5 14.9784M9 14.9784L8 16.9082M9 14.9784C7.67052 14.5942 6.51517 13.7715 6.10368 13.4082L4.5 14.9082",
    stroke: "#9FAAB8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHiddenIcon);
export default __webpack_public_path__ + "static/media/eyeHiddenIcon.3351a0013380ab12cb7426e8c1046759.svg";
export { ForwardRef as ReactComponent };